import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const sectors = [
  {
    tag: "01",
    name: "Mining & Extraction",
    img: "https://images.pexels.com/photos/10292870/pexels-photo-10292870.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    body: "Bathurst Mining Camp, Sussex potash and the critical-minerals corridor at Belledune — 20 years securing NB's most demanding extractive-industry sites.",
    to: "/sectors/mining",
    cta: "Sector Case Studies",
  },
  {
    tag: "02",
    name: "Ports & Marine",
    img: "https://images.unsplash.com/photo-1529747598642-d0b4e3667314?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHxzZWN1cml0eSUyMGd1YXJkJTIwbmlnaHQlMjBwYXRyb2x8ZW58MHx8fHwxNzg0OTIzODM0fDA&ixlib=rb-4.1.0&q=85",
    body: "Port Saint John, Belledune, Miramichi & Bayside — cargo, cruise, and terminal protection under transport-security regulation.",
    to: "/services/uniformed-security-guards",
    cta: "Related Service",
  },
  {
    tag: "03",
    name: "Industrial & Construction",
    img: "https://images.unsplash.com/photo-1617897711385-df9c86b7dfe3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxzdXJ2ZWlsbGFuY2UlMjBjYW1lcmElMjBjY3R2JTIwZGFya3xlbnwwfHx8fDE3ODQ5MjM4MzR8MA&ixlib=rb-4.1.0&q=85",
    body: "Copper theft prevention, hot-work fire watch, gate control and site-safety compliance for New Brunswick's largest infrastructure projects.",
    to: "/services/construction-site-security",
    cta: "Related Service",
  },
];

export default function SectorsSection() {
  return (
    <section
      data-testid="sectors-section"
      className="border-t border-border bg-background"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-24 md:py-32">
        <div className="flex items-end justify-between mb-16 gap-8">
          <div>
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground mb-6">
              [ Sectors ]
            </div>
            <h2 className="font-serif font-light text-4xl md:text-6xl tracking-tighter leading-[0.95]">
              Environments we <i className="text-primary">command.</i>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">
          {sectors.map((s, i) => (
            <motion.div
              key={s.tag}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{
                duration: 0.8,
                delay: i * 0.1,
                ease: [0.76, 0, 0.24, 1],
              }}
            >
              <Link
                to={s.to}
                data-testid={`sector-card-${s.tag}`}
                className="group block"
              >
                <div className="relative overflow-hidden border border-border aspect-[4/5] mb-6">
                  <img
                    src={s.img}
                    alt={s.name}
                    className="absolute inset-0 w-full h-full object-cover grayscale contrast-125 group-hover:scale-105 group-hover:grayscale-0 transition-all duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent" />
                  <div className="absolute top-4 left-4 right-4 flex justify-between items-start">
                    <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-white/80">
                      [ {s.tag} ]
                    </div>
                    <ArrowUpRight
                      size={18}
                      strokeWidth={1.2}
                      className="text-white/80 group-hover:text-primary group-hover:-translate-y-1 group-hover:translate-x-1 transition-all"
                    />
                  </div>
                  <div className="absolute bottom-6 left-6 right-6">
                    <h3 className="font-serif text-2xl md:text-3xl tracking-tight leading-tight">
                      {s.name}
                    </h3>
                  </div>
                </div>
                <p className="text-foreground/70 leading-relaxed max-w-md mb-3">
                  {s.body}
                </p>
                <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-primary group-hover:tracking-[0.35em] transition-all">
                  {s.cta} →
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
